export default "__VITE_ASSET__F1l5v$I1__"